/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrderCountry } from './OrderCountry';
import {
    OrderCountryFromJSON,
    OrderCountryFromJSONTyped,
    OrderCountryToJSON,
    OrderCountryToJSONTyped,
} from './OrderCountry';
import type { MoneyOutput } from './MoneyOutput';
import {
    MoneyOutputFromJSON,
    MoneyOutputFromJSONTyped,
    MoneyOutputToJSON,
    MoneyOutputToJSONTyped,
} from './MoneyOutput';

/**
 * 
 * @export
 * @interface CountryStatistics
 */
export interface CountryStatistics {
    /**
     * 
     * @type {OrderCountry}
     * @memberof CountryStatistics
     */
    country?: OrderCountry;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof CountryStatistics
     */
    turnoverNet?: MoneyOutput;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof CountryStatistics
     */
    turnoverGross?: MoneyOutput;
}

/**
 * Check if a given object implements the CountryStatistics interface.
 */
export function instanceOfCountryStatistics(value: object): value is CountryStatistics {
    return true;
}

export function CountryStatisticsFromJSON(json: any): CountryStatistics {
    return CountryStatisticsFromJSONTyped(json, false);
}

export function CountryStatisticsFromJSONTyped(json: any, ignoreDiscriminator: boolean): CountryStatistics {
    if (json == null) {
        return json;
    }
    return {
        
        'country': json['country'] == null ? undefined : OrderCountryFromJSON(json['country']),
        'turnoverNet': json['turnoverNet'] == null ? undefined : MoneyOutputFromJSON(json['turnoverNet']),
        'turnoverGross': json['turnoverGross'] == null ? undefined : MoneyOutputFromJSON(json['turnoverGross']),
    };
}

export function CountryStatisticsToJSON(json: any): CountryStatistics {
    return CountryStatisticsToJSONTyped(json, false);
}

export function CountryStatisticsToJSONTyped(value?: CountryStatistics | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'country': OrderCountryToJSON(value['country']),
        'turnoverNet': MoneyOutputToJSON(value['turnoverNet']),
        'turnoverGross': MoneyOutputToJSON(value['turnoverGross']),
    };
}

